<template>
  <div class="container bg-white pt-5">
    <div class="row">
      <div class="col-md-4">
        <market-indices></market-indices>
      </div>
      <div class="col-md-4">
        <market-aggregates></market-aggregates>
      </div>
      <div class="col-md-4">
        <ad-ratio></ad-ratio>
      </div>
    </div>
  </div>
</template>

<script>
import MarketIndices from "./MarketIndices.vue";
import MarketAggregates from "./MarketAggregates.vue";
import AdRatio from './AdRatio.vue'
export default {
  components: {
    MarketIndices,
    MarketAggregates,
    AdRatio
  },
};
</script>

<style></style>
